// extracted by mini-css-extract-plugin
module.exports =  {"layout":"layout--wrSaD","layout-main":"layout-main--WqYt8","layoutMain":"layout-main--WqYt8","layout-story":"layout-story--qzeu6","layoutStory":"layout-story--qzeu6"};